import React from "react";
import synopsisStore from "stores/new-synopsis";
import DOMPurify from "dompurify";

const MemberTransitionBanner = () => {
  const { banner } = synopsisStore.transitionBannerInfo || {};
  const sanitizedBanner = DOMPurify.sanitize(banner, {
    USE_PROFILES: { html: true },
  });
  if (!banner) return null;

  return (
    <div className="member-transition-banner">
      <span dangerouslySetInnerHTML={{ __html: sanitizedBanner }} />
    </div>
  );
};

export default MemberTransitionBanner;
